import { render, staticRenderFns } from "./BlockType5.vue?vue&type=template&id=6e5d307a&scoped=true"
import script from "./BlockType5.vue?vue&type=script&lang=ts"
export * from "./BlockType5.vue?vue&type=script&lang=ts"
import style0 from "./BlockType5.vue?vue&type=style&index=0&id=6e5d307a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5d307a",
  null
  
)

export default component.exports